<script>
  import { scale } from "svelte/transition";

  export let showDesc = false;
  export let photo;
  export let graphic;
  export let photo2;
  export let graphic2;
  export let name;

  let showPhotoModal = false;

  const handleShowPhoto = () => {
    photo = photo?.replaceAll("I-AM-GROOT-BRO", "cloudinary");
    graphic = graphic?.replaceAll("I-AM-GROOT-BRO", "cloudinary");
    photo2 = photo2?.replaceAll("I-AM-GROOT-BRO", "cloudinary");
    graphic2 = graphic2?.replaceAll("I-AM-GROOT-BRO", "cloudinary");
    setTimeout(() => {
      showPhotoModal = true;
    }, 300);
  };
  const handleHidePhoto = () => {
    photo = photo?.replaceAll("cloudinary", "I-AM-GROOT-BRO");
    graphic = graphic?.replaceAll("cloudinary", "I-AM-GROOT-BRO");
    photo2 = photo2?.replaceAll("cloudinary", "I-AM-GROOT-BRO");
    graphic2 = graphic2?.replaceAll("cloudinary", "I-AM-GROOT-BRO");
    showPhotoModal = false;
  };
</script>

<button class="btn btn-secondary mr-2" on:click={handleShowPhoto}>
  {#if showDesc}
    <i class="mr-2 fas fa-image text-xl" />
    Show Image
  {:else}
    <i class="fas fa-image text-base" />
  {/if}
</button>

{#if showPhotoModal}
  <div
    on:click|self={handleHidePhoto}
    class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black/50"
    style="z-index: 999;"
  >
    <div
      transition:scale
      class="relative product-frame-container bg-gray-50 rounded-lg shadow-2xl py-4 px-5 border-t-2 border-brand overflow-auto"
    >
      <div class="flex justify-between mb-4 absolute top-2 right-4 left-4">
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center">
            <i class="fas fa-image mr-2 text-xl text-brand" />
            <div class="text-sm flex items-center capitalize">
              {name}
            </div>
          </div>
          <button class="btn btn-secondary" on:click={handleHidePhoto}>
            <i class="fas fa-times-circle text-base" />
          </button>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-x-8 gap-y-4 pt-4">
        {#if photo}
          <img src={photo} alt="product" style="height: 90%;" />
        {/if}
        {#if graphic}
          <img src={graphic} alt="graphic" style="height: 90%;" />
        {/if}
        {#if photo2}
          <img src={photo2} alt="product" style="height: 90%;" />
        {/if}
        {#if graphic2}
          <img src={graphic2} alt="graphic" style="height: 90%;" />
        {/if}
      </div>
    </div>
  </div>
{/if}
